import 'twin.macro';
import React, { useRef, useState } from 'react';
import Dialog from '@teetsh/app/src/components/Dialog';
import Button from '@teetsh/app/src/components/Buttons/Button';
import {
  SchoolSelector,
  Option,
} from '@teetsh/app/src/components/EntitiesSelectorModals/SchoolSelector';
import { useTranslation } from 'react-i18next';

interface Props {
  onClose: () => void;
  title: string;
  isOpen: boolean;
  onConfirm: (v: Option) => Promise<any>;
  confirmLabel?: string;
  currentSchoolId?: string;
  children?: any;
}

export function SchoolSelectorModal(props: Props) {
  const { onClose, onConfirm, title, isOpen, confirmLabel, children } = props;
  const [entitiesSelected, setEntitiesSelected] = useState<Option | undefined>(
    undefined,
  );
  const { t } = useTranslation(['common']);
  const completeButtonRef = useRef(null);

  return (
    <Dialog
      size="md"
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      initialFocus={completeButtonRef}
    >
      <Dialog.Body>
        {children}
        <div tw="mb-4">
          <SchoolSelector
            currentSchoolId={props.currentSchoolId}
            value={entitiesSelected?.school?.id}
            onChange={setEntitiesSelected}
          />
        </div>
      </Dialog.Body>
      <Dialog.Footer>
        <Button large minimal onClick={onClose}>
          {t('common:buttons.cancel')}
        </Button>
        <Button
          large
          intent="primary"
          disabled={!entitiesSelected}
          onClick={() => {
            if (entitiesSelected) {
              return onConfirm(entitiesSelected).then(() => onClose());
            }
            return Promise.resolve();
          }}
        >
          {confirmLabel || t('common:buttons.move')}
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
}
